import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import Button from "../common/Button";
import Input from "../common/Input";
import { partnerService } from "../../services/partners";
import toast from "react-hot-toast";

const ProspectForm = ({ prospect, onSuccess }) => {
  const queryClient = useQueryClient();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: prospect || {},
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (prospect) {
      reset({
        ...prospect,
        followUpDate: prospect.followUpDate?.split("T")[0] || "",
      });
    } else {
      reset({});
    }
  }, [prospect, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (prospect) {
        await partnerService.updateProspect(prospect._id, data);
        toast.success("Prospect updated");
      } else {
        await partnerService.createProspect(data);
        toast.success("Prospect created");
      }
      queryClient.invalidateQueries({ queryKey: ["partner-prospects"] });
      reset();
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Input
        label="Name"
        {...register("name", { required: "Name is required" })}
        error={errors.name?.message}
      />
      <Input label="Company" {...register("company")} />
      <Input label="Website" {...register("website")} />
      <Input label="Email" type="email" {...register("email")} />
      <Input label="Phone" {...register("phone")} />
      <div>
        <label className="block text-sm font-medium mb-1">Contacted Via</label>
        <select
          {...register("contactedVia")}
          className="w-full border rounded p-2"
        >
          <option value="">Select</option>
          <option value="linkedin">LinkedIn</option>
          <option value="website">Website</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="email">Email</option>
          <option value="cold_call">Cold Call</option>
          <option value="referral">Referral</option>
          <option value="instagram">Instagram</option>
          <option value="facebook">Facebook</option>
          <option value="twitter">Twitter</option>
          <option value="other">Other</option>
        </select>
      </div>
      <Input label="LinkedIn Profile" {...register("linkedinProfile")} />
      <Input label="Designation" {...register("designation")} />
      <Input label="Industry" {...register("industry")} />
      <Input label="City" {...register("city")} />
      <div>
        <label className="block text-sm font-medium mb-1">Status</label>
        <select
          {...register("status")}
          className="w-full border rounded p-2"
        >
          <option value="new">New</option>
          <option value="contacted">Contacted</option>
          <option value="interested">Interested</option>
          <option value="negotiating">Negotiating</option>
          <option value="converted">Converted</option>
          <option value="lost">Lost</option>
        </select>
      </div>
      <Input
        label="Follow Up Date"
        type="date"
        {...register("followUpDate")}
      />
      <Button type="submit" disabled={loading}>
        {loading ? "Saving..." : prospect ? "Update" : "Create"}
      </Button>
    </form>
  );
};

export default ProspectForm;
